const isChartering = window.location.host.includes('chartering.orcas')

if (isChartering) {
  // Note that .replace will only replace the first occurrence so we don't mutate anything else
  const newUrl = window.location.href.replace('chartering.orcas', 'app.tms')
  window.location.replace(newUrl)
}

import './bootstrap'
